declare namespace $ {

	export class $bog_fragile_demo_collide_base2 extends $mol_view {
		icon( ): string
		title( ): string
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=base2.view.tree.d.ts.map